var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.871 1v3.402h9.666c.49.129 2.119.835 4.717 2.629 3.247 2.243 5.103 6.187 4.793 11.135-.247 3.959-4.793 7.81-7.654 8.66h-7.114V13.216h-4.02V31h11.051c1.52-.464 3.793-1.258 4.72-2 1.16-.928 8.506-5.887 6.186-15.783C27.151 4.402 21.253 1 18.007 1H6.87z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.825 21.18v3.325c1.855 0 5.907-.325 7.268-1.624 1.7-1.622 2.938-3.88 2.938-6.89 0-7.412-5.102-8.985-7.654-9.5H2v19.484h3.866v-15.54h8.118c1.47.154 4.485 1.483 4.794 5.566.31 4.083-3.84 5.155-5.953 5.18z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDf);
export default __webpack_public_path__ + "static/media/DF.9a4a6c9a3eee3bbdd2e8d8b07433be9e.svg";
export { ForwardRef as ReactComponent };